export enum SolidSurfaceConfigProfiles {
    PROFILED = 'profiled',
    CORNER = 'corner',
    UPSTAND = 'upstand',
    DOWNTURN = 'downturn'
}
